import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataAPI, postDataAPI, putDataAPI } from "../../utils/FetchData";
import { setErrorAlert, setLoader, setSuccessAlert } from "../alert/alertSlice";
// import { get_file_order, get_folder_order, get_folder_thunk } from "../folder/folderThunk";
// import { get_todo_order, get_todo_thunk } from "../todo/todoThunk";
// import { clearTodos } from "../todo/todoSlice";
// import { clearFolder } from "../folder/folderSlice";
import { setIsLogin } from "./authSlice";
import { USER_AU_TOKEN, USER_AU_USER } from "../../common/key";
// import { get_opentabs_thunk } from "../opentab/opentabThunk";
// import { clearOpenTabs } from "../opentab/opentabSlice";
// import { clearShortcuts } from "../shortcut/shortcutSlice";
// import { get_shortcut_thunk } from "../shortcut/shortcutThunk";

// New Register Thunk
export const register_thunk = createAsyncThunk(
  "user/auth/register",
  async (formData, thunkAPI) => {
    try {
      // thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "user/auth/register",
        formData,
        null
      );
      thunkAPI.dispatch(setSuccessAlert(response?.data?.message || "Registration successful"));
      // thunkAPI.dispatch(setLoader(false));
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Registration failed. Please try again.")
      );
      // thunkAPI.dispatch(setLoader(false));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Registration failed. Please try again."
      );
    }
  }
);

// New Login Thunk
export const login_thunk = createAsyncThunk(
  "user/auth/login",
  async (formData, thunkAPI) => {
    try {
      // thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "user/auth/login",
        formData,
        null
      );

      
    
      if(response?.data?.data?.user?.isVerified){
        localStorage.setItem(
          USER_AU_TOKEN,
          JSON.stringify(response?.data?.data?.token)
        );
        localStorage.setItem(
          USER_AU_USER,
          JSON.stringify(response?.data?.data?.user)
        );
        thunkAPI.dispatch(setIsLogin(true));
        thunkAPI.dispatch(setSuccessAlert("Login successful"));
      }

      // thunkAPI.dispatch(setLoader(false));
      
      // Commented until we have these implemented
      // thunkAPI.dispatch(
      //   sync_data_thunk({ token: response?.data?.data?.token })
      // );
      
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Login failed. Please check your credentials.")
      );
      // thunkAPI.dispatch(setLoader(false));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Login failed. Please check your credentials."
      );
    }
  }
);

// New Verify Code Thunk
export const verify_code_thunk = createAsyncThunk(
  "user/auth/verify-code",
  async (formData, thunkAPI) => {
    try {
      // thunkAPI.dispatch(setLoader(true));
      const response = await postDataAPI(
        "user/auth/verify-code",
        formData,
        null
      );
        localStorage.setItem(
          USER_AU_TOKEN,
          JSON.stringify(response?.data?.data?.token)
        );
        localStorage.setItem(
          USER_AU_USER,
          JSON.stringify(response?.data?.data?.user)
        );
        thunkAPI.dispatch(setIsLogin(true));
        thunkAPI.dispatch(setSuccessAlert("Login successful"));
    
      
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Verification failed. Please try again.")
      );
      // thunkAPI.dispatch(setLoader(false));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Verification failed. Please try again."
      );
    }
  }
);

// Forgot Password Thunk
export const forgot_password_thunk = createAsyncThunk(
  "user/auth/forgot-password",
  async (formData, thunkAPI) => {
    try {
      const response = await postDataAPI(
        "user/auth/forgot-password",
        formData,
        null
      );
      
      thunkAPI.dispatch(setSuccessAlert(response?.data?.message || "Password reset email sent. Please check your inbox."));
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to send reset email. Please try again.")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to send reset email. Please try again."
      );
    }
  }
);

// Reset Password Thunk
export const reset_password_thunk = createAsyncThunk(
  "user/auth/reset-password",
  async (formData, thunkAPI) => {
    try {
      // Extract token from formData 
      const { token, password, confirmPassword } = formData;
      
      const response = await postDataAPI(
        `user/auth/reset-password/${token}`,
        { password, confirmPassword },
        null
      );
      
      thunkAPI.dispatch(setSuccessAlert(response?.data?.message || "Password has been reset successfully"));
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to reset password. Please try again.")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to reset password. Please try again."
      );
    }
  }
);

export const logout_thunk = createAsyncThunk(
  "auth/logout",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(
        setIsLogin(false)
      )
      // Commented out undefined functions
      // thunkAPI.dispatch(
      //   clearFolder()
      // )
      // thunkAPI.dispatch(
      //   clearTodos()
      // )
      // thunkAPI.dispatch(
      //   clearOpenTabs()
      // )
      // thunkAPI.dispatch(
      //   clearShortcuts()
      // )
      localStorage.clear()

      // Optionally, if you are using Electron's API for Google OAuth, call the logout function (if available)
      
      return;
      // window.location.href = "/";
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
);


export const sync_data_thunk = createAsyncThunk(
  "auth/sync_data",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true))
      // Create an array of all dispatch promises to run in parallel
      // Commented out undefined functions
      // const promises = [
      //   thunkAPI.dispatch(get_folder_thunk({ token: tempData.token })),
      //   thunkAPI.dispatch(get_todo_thunk({ token: tempData.token })),
      //   thunkAPI.dispatch(get_opentabs_thunk({ token: tempData.token })),
      //   thunkAPI.dispatch(get_shortcut_thunk({ token: tempData.token })),
      //   thunkAPI.dispatch(get_user_thunk({ token: tempData.token })),
      //   thunkAPI.dispatch(get_folder_order({ token: tempData.token })),
      //   thunkAPI.dispatch(get_file_order({ token: tempData.token })),
      //   thunkAPI.dispatch(get_todo_order({ token: tempData.token }))
      // ];

      // Wait for all requests to complete
      // await Promise.all(promises);
      
      // For now, just get the user data
      await thunkAPI.dispatch(get_user_thunk({ token: tempData.token }));
      
      thunkAPI.dispatch(setLoader(false))

      return;
    } catch (error) {
      thunkAPI.dispatch(setLoader(false))

      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
);

export const get_user_thunk = createAsyncThunk(
  "user/auth/get_user",
  async (tempData, thunkAPI) => {
    try {
      const get_user_thunk_res = await getDataAPI(
        "user/auth/get_user",
        tempData.token
      );
      return get_user_thunk_res.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
)

export const update_user_thunk = createAsyncThunk(
  "user/auth/update_user",
  async (tempData, thunkAPI) => {
    try {
      const update_user_thunk_res = await putDataAPI(
        "user/auth/update_user",
        tempData?.data,
        tempData.token
      );
      return update_user_thunk_res.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
)


export const contact_us_thunk = createAsyncThunk(
  "user/auth/contact-us",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true))
      const response = await postDataAPI(
        "user/auth/contact-us",
        tempData?.data,
        null
      );
      thunkAPI.dispatch(setSuccessAlert(response?.data?.message))
      thunkAPI.dispatch(setLoader(false))
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
)

// Edit Profile Thunk
export const edit_profile_thunk = createAsyncThunk(
  "user/auth/edit-profile",
  async (formData, thunkAPI) => {
    try {
      // const token = JSON.parse(localStorage.getItem(USER_AU_TOKEN));
      const response = await putDataAPI(
        "user/auth/edit-profile",
        formData,
        // token
      );
      
      // Update user in localStorage
      if (response?.data?.data?.user) {
        localStorage.setItem(
          USER_AU_USER,
          JSON.stringify(response.data.data.user)
        );
      }
      
      thunkAPI.dispatch(setSuccessAlert(response?.data?.message || "Profile updated successfully"));
      return response.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Failed to update profile. Please try again.")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Failed to update profile. Please try again."
      );
    }
  }
);